import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Int64 from "bs-platform/lib/es6/int64.js";
import * as Format from "bs-platform/lib/es6/format.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as Stream from "bs-platform/lib/es6/stream.js";
import * as Hashtbl from "bs-platform/lib/es6/hashtbl.js";
import * as Caml_array from "bs-platform/lib/es6/caml_array.js";
import * as Caml_int32 from "bs-platform/lib/es6/caml_int32.js";
import * as Caml_int64 from "bs-platform/lib/es6/caml_int64.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as ArrayLabels from "bs-platform/lib/es6/arrayLabels.js";
import * as Caml_format from "bs-platform/lib/es6/caml_format.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Bolt0_fn$Bolt0 from "bolt0/./bolt0_fn.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function Make(Int32_genarray, Int64_genarray, Float32_genarray, Float64_genarray) {
  var convert_genarray = function convert_genarray(Genarray, of_elem, of_array, data) {
    var num_dims = Curry._1(Genarray.num_dims, data);

    var unroll$prime = function unroll$prime(indices) {
      var match = num_dims === indices.length;

      if (match) {
        return Curry._1(of_elem, Curry._2(Genarray.get, data, indices));
      } else {
        return Curry._1(of_array, ArrayLabels.init(Curry._2(Genarray.nth_dim, data, indices.length), function (i) {
          return unroll$prime($$Array.append(indices,
          /* array */
          [i]));
        }));
      }
    };

    return unroll$prime(
    /* array */
    []);
  };

  var create_float32 = function create_float32(dims) {
    return (
      /* `Float32_genarray */
      [28091885, Curry._1(Float32_genarray.create, dims)]
    );
  };

  var create_float64 = function create_float64(dims) {
    return (
      /* `Float64_genarray */
      [81581934, Curry._1(Float64_genarray.create, dims)]
    );
  };

  var create_int32 = function create_int32(dims) {
    return (
      /* `Int32_genarray */
      [-714735238, Curry._1(Int32_genarray.create, dims)]
    );
  };

  var create_int64 = function create_int64(dims) {
    return (
      /* `Int64_genarray */
      [-661245189, Curry._1(Int64_genarray.create, dims)]
    );
  };

  var int_exn = function int_exn(param) {
    var variant = param[0];

    if (variant !== 3654863) {
      if (variant >= 365180284) {
        return param[1] | 0;
      } else {
        return Caml_format.caml_int_of_string(param[1]);
      }
    } else {
      return param[1];
    }
  };

  var float_exn = function float_exn(param) {
    var variant = param[0];

    if (variant !== 3654863 && variant < 365180284) {
      return Caml_format.caml_float_of_string(param[1]);
    } else {
      return param[1];
    }
  };

  var empty_float32_001 = Curry._1(Float32_genarray.create,
  /* array */
  []);

  var empty_float32 =
  /* `Float32_genarray */
  [28091885, empty_float32_001];

  var get_float = function get_float(floats, indices) {
    if (floats[0] >= 81581934) {
      return Curry._2(Float64_genarray.get, floats[1], indices);
    } else {
      return Curry._2(Float32_genarray.get, floats[1], indices);
    }
  };

  var get_int = function get_int(ints, indices) {
    if (ints[0] >= -661245189) {
      return Caml_int64.to_int32(Curry._2(Int64_genarray.get, ints[1], indices));
    } else {
      return Curry._2(Int32_genarray.get, ints[1], indices);
    }
  };

  var get = function get(bigdata, indices) {
    if (bigdata[0] >= 28091885) {
      return (
        /* `Float */
        [365180284, get_float(bigdata, indices)]
      );
    } else {
      return (
        /* `Int */
        [3654863, get_int(bigdata, indices)]
      );
    }
  };

  var set_int = function set_int(ints, indices, v) {
    if (ints[0] >= -661245189) {
      return Curry._3(Int64_genarray.set, ints[1], indices, Caml_int64.of_int32(v));
    } else {
      return Curry._3(Int32_genarray.set, ints[1], indices, v);
    }
  };

  var set_float = function set_float(floats, indices, v) {
    if (floats[0] >= 81581934) {
      return Curry._3(Float64_genarray.set, floats[1], indices, v);
    } else {
      return Curry._3(Float32_genarray.set, floats[1], indices, v);
    }
  };

  var set = function set(bigdata, indices, v) {
    if (bigdata[0] >= 28091885) {
      return set_float(bigdata, indices, float_exn(v));
    } else {
      return set_int(bigdata, indices, int_exn(v));
    }
  };

  var map = function map(of_array, of_float, of_int32, of_int64, bigdata) {
    var variant = bigdata[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return convert_genarray(Float64_genarray, of_float, of_array, bigdata[1]);
      } else {
        return convert_genarray(Float32_genarray, of_float, of_array, bigdata[1]);
      }
    } else if (variant >= -661245189) {
      return convert_genarray(Int64_genarray, of_int64, of_array, bigdata[1]);
    } else {
      return convert_genarray(Int32_genarray, of_int32, of_array, bigdata[1]);
    }
  };

  var num_dims = function num_dims(t) {
    var variant = t[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Curry._1(Float64_genarray.num_dims, t[1]);
      } else {
        return Curry._1(Float32_genarray.num_dims, t[1]);
      }
    } else if (variant >= -661245189) {
      return Curry._1(Int64_genarray.num_dims, t[1]);
    } else {
      return Curry._1(Int32_genarray.num_dims, t[1]);
    }
  };

  var size_in_bytes = function size_in_bytes(t) {
    var variant = t[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Curry._1(Float64_genarray.size_in_bytes, t[1]);
      } else {
        return Curry._1(Float32_genarray.size_in_bytes, t[1]);
      }
    } else if (variant >= -661245189) {
      return Curry._1(Int64_genarray.size_in_bytes, t[1]);
    } else {
      return Curry._1(Int32_genarray.size_in_bytes, t[1]);
    }
  };

  var nth_dim = function nth_dim(t) {
    var variant = t[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Curry._1(Float64_genarray.nth_dim, t[1]);
      } else {
        return Curry._1(Float32_genarray.nth_dim, t[1]);
      }
    } else if (variant >= -661245189) {
      return Curry._1(Int64_genarray.nth_dim, t[1]);
    } else {
      return Curry._1(Int32_genarray.nth_dim, t[1]);
    }
  };

  var dims = function dims(t) {
    var variant = t[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Curry._1(Float64_genarray.dims, t[1]);
      } else {
        return Curry._1(Float32_genarray.dims, t[1]);
      }
    } else if (variant >= -661245189) {
      return Curry._1(Int64_genarray.dims, t[1]);
    } else {
      return Curry._1(Int32_genarray.dims, t[1]);
    }
  };

  var is_empty = function is_empty(t) {
    return num_dims(t) === 0;
  };

  var foldi = function foldi(init, f, data) {
    var num_dims$1 = num_dims(data);

    var unroll$prime = function unroll$prime(accum, indices) {
      var match = num_dims$1 === indices.length;

      if (match) {
        return Curry._3(f, indices, accum, get(data, indices));
      } else {
        var nth_dim$1 = Curry._1(nth_dim(data), indices.length);

        var stream = Stream.from(function (x) {
          var match = x < nth_dim$1;

          if (match) {
            return x;
          }
        });
        var _accum = accum;

        while (true) {
          var accum$1 = _accum;
          var i;

          try {
            i = Stream.next(stream);
          } catch (exn) {
            if (exn === Stream.Failure) {
              return accum$1;
            } else {
              throw exn;
            }
          }

          _accum = unroll$prime(accum$1, $$Array.append(indices,
          /* array */
          [i]));
          continue;
        }

        ;
      }
    };

    return unroll$prime(init,
    /* array */
    []);
  };

  var to_term = function to_term(t) {
    return t;
  };

  var sub_left_int = function sub_left_int(t, i, j) {
    if (t[0] >= -661245189) {
      return (
        /* `Int64_genarray */
        [-661245189, Curry._3(Int64_genarray.sub_left, t[1], i, j)]
      );
    } else {
      return (
        /* `Int32_genarray */
        [-714735238, Curry._3(Int32_genarray.sub_left, t[1], i, j)]
      );
    }
  };

  var sub_left_float = function sub_left_float(t, i, j) {
    if (t[0] >= 81581934) {
      return (
        /* `Float64_genarray */
        [81581934, Curry._3(Float64_genarray.sub_left, t[1], i, j)]
      );
    } else {
      return (
        /* `Float32_genarray */
        [28091885, Curry._3(Float32_genarray.sub_left, t[1], i, j)]
      );
    }
  };

  var sub_left = function sub_left(t, i, j) {
    if (t[0] >= 28091885) {
      return sub_left_float(t, i, j);
    } else {
      return sub_left_int(t, i, j);
    }
  };

  var slice_left_int = function slice_left_int(t, i) {
    if (t[0] >= -661245189) {
      return (
        /* `Int64_genarray */
        [-661245189, Curry._2(Int64_genarray.slice_left, t[1], i)]
      );
    } else {
      return (
        /* `Int32_genarray */
        [-714735238, Curry._2(Int32_genarray.slice_left, t[1], i)]
      );
    }
  };

  var slice_left_float = function slice_left_float(t, i) {
    if (t[0] >= 81581934) {
      return (
        /* `Float64_genarray */
        [81581934, Curry._2(Float64_genarray.slice_left, t[1], i)]
      );
    } else {
      return (
        /* `Float32_genarray */
        [28091885, Curry._2(Float32_genarray.slice_left, t[1], i)]
      );
    }
  };

  var slice_left = function slice_left(t, i) {
    if (t[0] >= 28091885) {
      return slice_left_float(t, i);
    } else {
      return slice_left_int(t, i);
    }
  };

  var singleton = function singleton(data) {
    return (
      /* `String_array */
      [-867361653,
      /* array */
      [data]]
    );
  };

  var empty_001 =
  /* array */
  [""];
  var empty =
  /* `String_array */
  [-867361653, empty_001];

  var of_array = function of_array(strings) {
    return (
      /* `String_array */
      [-867361653, strings]
    );
  };

  var of_matrix = function of_matrix(string_matrix) {
    return (
      /* `String_matrix */
      [-83649777, string_matrix]
    );
  };

  var create = function create(dims) {
    var len = dims.length;

    if (len < 3) {
      switch (len) {
        case 0:
          break;

        case 1:
          var x = dims[0];
          return (
            /* `String_array */
            [-867361653, Caml_array.caml_make_vect(x, "")]
          );

        case 2:
          var x$1 = dims[0];
          var y = dims[1];
          return (
            /* `String_matrix */
            [-83649777, ArrayLabels.make_matrix(x$1, y, "")]
          );
      }
    }

    return Pervasives.failwith(Curry._1(Printf.sprintf(
    /* Format */
    [
    /* String_literal */
    Block.__(11, ["invalid number of dimension: ",
    /* Int */
    Block.__(4, [
    /* Int_d */
    0,
    /* No_padding */
    0,
    /* No_precision */
    0,
    /* End_of_format */
    0])]), "invalid number of dimension: %d"]), dims.length));
  };

  var get$1 = function get$1(strings, indices) {
    var len = indices.length;

    if (len >= 3) {
      return Pervasives.failwith("invalid dimensions");
    } else {
      switch (len) {
        case 0:
          return Pervasives.failwith("invalid dimensions");

        case 1:
          var x = indices[0];

          if (typeof strings === "number" || strings[0] !== -867361653) {
            return Pervasives.failwith("invalid dimensions");
          } else {
            return Caml_array.caml_array_get(strings[1], x);
          }

        case 2:
          var x$1 = indices[0];
          var y = indices[1];

          if (typeof strings === "number" || strings[0] !== -83649777) {
            return Pervasives.failwith("invalid dimensions");
          } else {
            return Caml_array.caml_array_get(Caml_array.caml_array_get(strings[1], x$1), y);
          }

      }
    }
  };

  var num_dims$1 = function num_dims$1(t) {
    if (t[0] >= -83649777) {
      return 2;
    } else {
      return 1;
    }
  };

  var dims$1 = function dims$1(t) {
    if (t[0] >= -83649777) {
      var mat = t[1];
      var x = mat.length;

      if (x !== 0) {
        return (
          /* array */
          [x, Caml_array.caml_array_get(mat, 0).length]
        );
      } else {
        return (
          /* array */
          []
        );
      }
    } else {
      return (
        /* array */
        [t[1].length]
      );
    }
  };

  var set$1 = function set$1(t, indices, value) {
    if (t[0] >= -83649777) {
      if (indices.length === 2) {
        var x = indices[0];
        var y = indices[1];
        return Caml_array.caml_array_set(Caml_array.caml_array_get(t[1], x), y, value);
      }
    } else if (indices.length === 1) {
      var x$1 = indices[0];
      return Caml_array.caml_array_set(t[1], x$1, value);
    }

    return Pervasives.failwith(Curry._1(Printf.sprintf(
    /* Format */
    [
    /* String_literal */
    Block.__(11, ["invalid dimension for indices: ",
    /* Int */
    Block.__(4, [
    /* Int_d */
    0,
    /* No_padding */
    0,
    /* No_precision */
    0,
    /* End_of_format */
    0])]), "invalid dimension for indices: %d"]), indices.length));
  };

  var nth_dim$1 = function nth_dim$1(t, n) {
    return Caml_array.caml_array_get(dims$1(t), n);
  };

  var get_array = function get_array(t, indices) {
    var num_dims$2 = num_dims$1(t);
    var indices_len = indices.length;
    var dim_diff = num_dims$2 - indices_len | 0;

    if (dim_diff !== 1) {
      Pervasives.failwith(Curry._2(Printf.sprintf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["get_array: invalid index dimension: ",
      /* Int */
      Block.__(4, [
      /* Int_d */
      0,
      /* No_padding */
      0,
      /* No_precision */
      0,
      /* String_literal */
      Block.__(11, [", should be ",
      /* Int */
      Block.__(4, [
      /* Int_d */
      0,
      /* No_padding */
      0,
      /* No_precision */
      0,
      /* End_of_format */
      0])])])]), "get_array: invalid index dimension: %d, should be %d"]), indices_len, num_dims$2 - 1 | 0));
    }

    var last_dim = Caml_array.caml_array_get(dims$1(t), indices_len);
    return ArrayLabels.init(last_dim, function (i) {
      return get$1(t, $$Array.append(indices,
      /* array */
      [i]));
    });
  };

  var get_matrix = function get_matrix(t, indices) {
    var num_dims$2 = num_dims$1(t);
    var indices_len = indices.length;
    var dim_diff = num_dims$2 - indices_len | 0;

    if (dim_diff !== 2) {
      Pervasives.failwith(Curry._2(Printf.sprintf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["get_matrix: invalid index dimension: ",
      /* Int */
      Block.__(4, [
      /* Int_d */
      0,
      /* No_padding */
      0,
      /* No_precision */
      0,
      /* String_literal */
      Block.__(11, [", should be ",
      /* Int */
      Block.__(4, [
      /* Int_d */
      0,
      /* No_padding */
      0,
      /* No_precision */
      0,
      /* End_of_format */
      0])])])]), "get_matrix: invalid index dimension: %d, should be %d"]), indices_len, num_dims$2 - 2 | 0));
    }

    var last_dim = Caml_array.caml_array_get(dims$1(t), indices_len);
    return ArrayLabels.init(last_dim, function (i) {
      return get_array(t, $$Array.append(indices,
      /* array */
      [i]));
    });
  };

  var map$1 = function map$1(of_string, of_array, data) {
    var num_dims$2 = num_dims$1(data);

    var unroll$prime = function unroll$prime(indices) {
      var match = num_dims$2 === indices.length;

      if (match) {
        return Curry._1(of_string, get$1(data, indices));
      } else {
        return Curry._1(of_array, ArrayLabels.init(Caml_array.caml_array_get(dims$1(data), indices.length), function (i) {
          return unroll$prime($$Array.append(indices,
          /* array */
          [i]));
        }));
      }
    };

    return unroll$prime(
    /* array */
    []);
  };

  var foldi$1 = function foldi$1(init, f, data) {
    var num_dims$2 = num_dims$1(data);

    var unroll$prime = function unroll$prime(accum, indices) {
      var match = num_dims$2 === indices.length;

      if (match) {
        return Curry._3(f, indices, accum, get$1(data, indices));
      } else {
        return ArrayLabels.fold_left(function (accum$prime, i) {
          return unroll$prime(accum$prime, $$Array.append(indices,
          /* array */
          [i]));
        }, accum, ArrayLabels.init(Caml_array.caml_array_get(dims$1(data), indices.length), Bolt0_fn$Bolt0.id));
      }
    };

    return unroll$prime(init,
    /* array */
    []);
  };

  var to_term$1 = function to_term$1(t) {
    return (
      /* `Strings */
      [-968575390, t]
    );
  };

  var reverse_index = function reverse_index(to_data, t) {
    var init = Hashtbl.create(undefined, 100);
    var table = foldi$1(init, function (indices, hash, key) {
      var data = Curry._2(to_data, indices, key);

      Hashtbl.add(hash, key, data);
      return hash;
    }, t);
    return function (x) {
      try {
        return Caml_option.some(Hashtbl.find(table, x));
      } catch (exn) {
        if (exn === Caml_builtin_exceptions.not_found) {
          return;
        } else {
          throw exn;
        }
      }
    };
  };

  var size_in_bytes$1 = function size_in_bytes$1(t) {
    if (t[0] >= -83649777) {
      return ArrayLabels.fold_left(function (init, arr) {
        return ArrayLabels.fold_left(function (acc, s) {
          return acc + s.length | 0;
        }, init, arr);
      }, 0, t[1]);
    } else {
      return ArrayLabels.fold_left(function (acc, s) {
        return acc + s.length | 0;
      }, 1, t[1]);
    }
  };

  var is_empty$1 = function is_empty$1(t) {
    var match = num_dims$1(t);
    return match === 0;
  };

  var length = function length(t) {
    if (is_empty$1(t)) {
      return Int64.zero;
    } else {
      return ArrayLabels.fold_left(function (acc, x) {
        return Caml_int64.mul(acc, Caml_int64.of_int32(x));
      }, Int64.one, dims$1(t));
    }
  };

  var sub_left$1 = function sub_left$1(t, i, j) {
    if (t[0] >= -83649777) {
      return (
        /* `String_matrix */
        [-83649777, ArrayLabels.sub(t[1], i, j)]
      );
    } else {
      return (
        /* `String_array */
        [-867361653, ArrayLabels.sub(t[1], i, j)]
      );
    }
  };

  var slice_left$1 = function slice_left$1(t, i) {
    var len = i.length;

    if (len >= 3) {
      return Pervasives.failwith("slice_left: invalid indices");
    } else {
      switch (len) {
        case 0:
          return Pervasives.failwith("slice_left: invalid indices");

        case 1:
          var len$1 = i[0];

          if (t[0] >= -83649777) {
            var mat = t[1];
            return (
              /* `String_matrix */
              [-83649777, ArrayLabels.init(len$1, function (param) {
                return Caml_array.caml_array_get(mat, param);
              })]
            );
          } else {
            var arr = t[1];
            return (
              /* `String_array */
              [-867361653, ArrayLabels.init(len$1, function (param) {
                return Caml_array.caml_array_get(arr, param);
              })]
            );
          }

        case 2:
          var len_x = i[0];
          var len_y = i[1];

          if (typeof t === "number" || t[0] !== -83649777) {
            return Pervasives.failwith("slice_left: invalid indices");
          } else {
            var mat$1 = t[1];
            return (
              /* `String_matrix */
              [-83649777, ArrayLabels.map(function (arr) {
                return ArrayLabels.init(len_y, function (param) {
                  return Caml_array.caml_array_get(arr, param);
                });
              }, ArrayLabels.init(len_x, function (param) {
                return Caml_array.caml_array_get(mat$1, param);
              }))]
            );
          }

      }
    }
  };

  var foldi$2 = function foldi$2(init, f, t) {
    if (t[0] >= -714735238) {
      return foldi(init, Curry.__3(f), t);
    } else {
      return foldi$1(init, function (indices, acc, x) {
        return Curry._3(f, indices, acc,
        /* `String */
        [-976970511, x]);
      }, t[1]);
    }
  };

  var set$2 = function set$2(t, indices, value) {
    if (t[0] >= -714735238) {
      if (value[0] >= 3654863) {
        return set(t, indices, value);
      } else {
        return Pervasives.failwith("can't set string value on a numeric bigdata type");
      }
    } else if (value[0] >= 3654863) {
      return Pervasives.failwith("can't set numeric value on a strings bigdata type");
    } else {
      return set$1(t[1], indices, value[1]);
    }
  };

  var dims$2 = function dims$2(n) {
    if (n[0] >= -714735238) {
      return dims(n);
    } else {
      return dims$1(n[1]);
    }
  };

  var num_dims$2 = function num_dims$2(n) {
    if (n[0] >= -714735238) {
      return num_dims(n);
    } else {
      return num_dims$1(n[1]);
    }
  };

  var nth_dim$2 = function nth_dim$2(n) {
    if (n[0] >= -714735238) {
      return nth_dim(n);
    } else {
      var partial_arg = n[1];
      return function (param) {
        return Caml_array.caml_array_get(dims$1(partial_arg), param);
      };
    }
  };

  var get$2 = function get$2(t, indices) {
    if (t[0] >= -714735238) {
      return get(t, indices);
    } else {
      return (
        /* `String */
        [-976970511, get$1(t[1], indices)]
      );
    }
  };

  var int_exn$1 = function int_exn$1(t, indices) {
    if (t[0] >= -714735238) {
      return int_exn(get(t, indices));
    } else {
      return Pervasives.failwith("int_exn: expected integer bigdata but got strings");
    }
  };

  var float_exn$1 = function float_exn$1(t, indices) {
    if (t[0] >= -714735238) {
      return float_exn(get(t, indices));
    } else {
      return Pervasives.failwith("int_exn: expected float bigdata but got strings");
    }
  };

  var string_exn = function string_exn(t, indices) {
    if (t[0] >= -714735238) {
      return Pervasives.failwith("strings_exn: expected strings bigdata but got numeric");
    } else {
      return get$1(t[1], indices);
    }
  };

  var length$1 = function length$1(x) {
    return ArrayLabels.fold_left(Caml_int32.imul, 1, dims$2(x));
  };

  var sub_left$2 = function sub_left$2(t, i, j) {
    if (t[0] >= -714735238) {
      return sub_left(t, i, j);
    } else {
      return (
        /* `Strings */
        [-968575390, sub_left$1(t[1], i, j)]
      );
    }
  };

  var slice_left$2 = function slice_left$2(t, i) {
    if (t[0] >= -714735238) {
      return slice_left(t, i);
    } else {
      return (
        /* `Strings */
        [-968575390, slice_left$1(t[1], i)]
      );
    }
  };

  var pp_hum = function pp_hum(ppf, bigdata) {
    var variant = bigdata[0];

    if (variant !== -714735238) {
      if (variant >= 28091885) {
        if (variant >= 81581934) {
          return Format.fprintf(ppf,
          /* Format */
          [
          /* String_literal */
          Block.__(11, ["<float64-genarray>",
          /* End_of_format */
          0]), "<float64-genarray>"]);
        } else {
          return Format.fprintf(ppf,
          /* Format */
          [
          /* String_literal */
          Block.__(11, ["<float32-genarray>",
          /* End_of_format */
          0]), "<float32-genarray>"]);
        }
      } else if (variant >= -661245189) {
        return Format.fprintf(ppf,
        /* Format */
        [
        /* String_literal */
        Block.__(11, ["<int64-genarray>",
        /* End_of_format */
        0]), "<int64-genarray>"]);
      } else {
        return Format.fprintf(ppf,
        /* Format */
        [
        /* String_literal */
        Block.__(11, ["<strings>",
        /* End_of_format */
        0]), "<strings>"]);
      }
    } else {
      return Format.fprintf(ppf,
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["<int32-genarray>",
      /* End_of_format */
      0]), "<int32-genarray>"]);
    }
  };

  var cell_format = function cell_format(t) {
    var variant = t[0];

    if (variant >= -714735238) {
      if (variant >= 28091885) {
        return (
          /* Float */
          365180284
        );
      } else {
        return (
          /* Int */
          3654863
        );
      }
    } else {
      return (
        /* String */
        -976970511
      );
    }
  };

  return {
    Numeric: {
      create_float32: create_float32,
      create_float64: create_float64,
      create_int32: create_int32,
      create_int64: create_int64,
      int_exn: int_exn,
      float_exn: float_exn,
      empty_float32: empty_float32,
      get_float: get_float,
      get_int: get_int,
      get: get,
      set_int: set_int,
      set_float: set_float,
      set: set,
      map: map,
      num_dims: num_dims,
      size_in_bytes: size_in_bytes,
      nth_dim: nth_dim,
      dims: dims,
      is_empty: is_empty,
      foldi: foldi,
      to_term: to_term,
      sub_left: sub_left,
      sub_left_int: sub_left_int,
      sub_left_float: sub_left_float,
      slice_left: slice_left,
      slice_left_int: slice_left_int,
      slice_left_float: slice_left_float
    },
    Strings: {
      singleton: singleton,
      empty: empty,
      of_array: of_array,
      of_matrix: of_matrix,
      create: create,
      get: get$1,
      num_dims: num_dims$1,
      dims: dims$1,
      nth_dim: nth_dim$1,
      get_array: get_array,
      get_matrix: get_matrix,
      map: map$1,
      foldi: foldi$1,
      to_term: to_term$1,
      reverse_index: reverse_index,
      size_in_bytes: size_in_bytes$1,
      is_empty: is_empty$1,
      length: length,
      sub_left: sub_left$1,
      slice_left: slice_left$1,
      set: set$1
    },
    foldi: foldi$2,
    get: get$2,
    num_dims: num_dims$2,
    nth_dim: nth_dim$2,
    dims: dims$2,
    int_exn: int_exn$1,
    float_exn: float_exn$1,
    string_exn: string_exn,
    length: length$1,
    slice_left: slice_left$2,
    sub_left: sub_left$2,
    pp_hum: pp_hum,
    set: set$2,
    cell_format: cell_format
  };
}

function Make_sexp(Int32_genarray, Int64_genarray, Float32_genarray, Float64_genarray, Bigdata_strings) {
  var convert_genarray = function convert_genarray(Genarray, of_elem, of_array, data) {
    var num_dims = Curry._1(Genarray.num_dims, data);

    var unroll$prime = function unroll$prime(indices) {
      var match = num_dims === indices.length;

      if (match) {
        return Curry._1(of_elem, Curry._2(Genarray.get, data, indices));
      } else {
        return Curry._1(of_array, ArrayLabels.init(Curry._2(Genarray.nth_dim, data, indices.length), function (i) {
          return unroll$prime($$Array.append(indices,
          /* array */
          [i]));
        }));
      }
    };

    return unroll$prime(
    /* array */
    []);
  };

  var create_float32 = function create_float32(dims) {
    return (
      /* `Float32_genarray */
      [28091885, Curry._1(Float32_genarray.create, dims)]
    );
  };

  var create_float64 = function create_float64(dims) {
    return (
      /* `Float64_genarray */
      [81581934, Curry._1(Float64_genarray.create, dims)]
    );
  };

  var create_int32 = function create_int32(dims) {
    return (
      /* `Int32_genarray */
      [-714735238, Curry._1(Int32_genarray.create, dims)]
    );
  };

  var create_int64 = function create_int64(dims) {
    return (
      /* `Int64_genarray */
      [-661245189, Curry._1(Int64_genarray.create, dims)]
    );
  };

  var int_exn = function int_exn(param) {
    var variant = param[0];

    if (variant !== 3654863) {
      if (variant >= 365180284) {
        return param[1] | 0;
      } else {
        return Caml_format.caml_int_of_string(param[1]);
      }
    } else {
      return param[1];
    }
  };

  var float_exn = function float_exn(param) {
    var variant = param[0];

    if (variant !== 3654863 && variant < 365180284) {
      return Caml_format.caml_float_of_string(param[1]);
    } else {
      return param[1];
    }
  };

  var empty_float32_001 = Curry._1(Float32_genarray.create,
  /* array */
  []);

  var empty_float32 =
  /* `Float32_genarray */
  [28091885, empty_float32_001];

  var get_float = function get_float(floats, indices) {
    if (floats[0] >= 81581934) {
      return Curry._2(Float64_genarray.get, floats[1], indices);
    } else {
      return Curry._2(Float32_genarray.get, floats[1], indices);
    }
  };

  var get_int = function get_int(ints, indices) {
    if (ints[0] >= -661245189) {
      return Caml_int64.to_int32(Curry._2(Int64_genarray.get, ints[1], indices));
    } else {
      return Curry._2(Int32_genarray.get, ints[1], indices);
    }
  };

  var get = function get(bigdata, indices) {
    if (bigdata[0] >= 28091885) {
      return (
        /* `Float */
        [365180284, get_float(bigdata, indices)]
      );
    } else {
      return (
        /* `Int */
        [3654863, get_int(bigdata, indices)]
      );
    }
  };

  var set_int = function set_int(ints, indices, v) {
    if (ints[0] >= -661245189) {
      return Curry._3(Int64_genarray.set, ints[1], indices, Caml_int64.of_int32(v));
    } else {
      return Curry._3(Int32_genarray.set, ints[1], indices, v);
    }
  };

  var set_float = function set_float(floats, indices, v) {
    if (floats[0] >= 81581934) {
      return Curry._3(Float64_genarray.set, floats[1], indices, v);
    } else {
      return Curry._3(Float32_genarray.set, floats[1], indices, v);
    }
  };

  var set = function set(bigdata, indices, v) {
    if (bigdata[0] >= 28091885) {
      return set_float(bigdata, indices, float_exn(v));
    } else {
      return set_int(bigdata, indices, int_exn(v));
    }
  };

  var map = function map(of_array, of_float, of_int32, of_int64, bigdata) {
    var variant = bigdata[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return convert_genarray(Float64_genarray, of_float, of_array, bigdata[1]);
      } else {
        return convert_genarray(Float32_genarray, of_float, of_array, bigdata[1]);
      }
    } else if (variant >= -661245189) {
      return convert_genarray(Int64_genarray, of_int64, of_array, bigdata[1]);
    } else {
      return convert_genarray(Int32_genarray, of_int32, of_array, bigdata[1]);
    }
  };

  var num_dims = function num_dims(t) {
    var variant = t[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Curry._1(Float64_genarray.num_dims, t[1]);
      } else {
        return Curry._1(Float32_genarray.num_dims, t[1]);
      }
    } else if (variant >= -661245189) {
      return Curry._1(Int64_genarray.num_dims, t[1]);
    } else {
      return Curry._1(Int32_genarray.num_dims, t[1]);
    }
  };

  var size_in_bytes = function size_in_bytes(t) {
    var variant = t[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Curry._1(Float64_genarray.size_in_bytes, t[1]);
      } else {
        return Curry._1(Float32_genarray.size_in_bytes, t[1]);
      }
    } else if (variant >= -661245189) {
      return Curry._1(Int64_genarray.size_in_bytes, t[1]);
    } else {
      return Curry._1(Int32_genarray.size_in_bytes, t[1]);
    }
  };

  var nth_dim = function nth_dim(t) {
    var variant = t[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Curry._1(Float64_genarray.nth_dim, t[1]);
      } else {
        return Curry._1(Float32_genarray.nth_dim, t[1]);
      }
    } else if (variant >= -661245189) {
      return Curry._1(Int64_genarray.nth_dim, t[1]);
    } else {
      return Curry._1(Int32_genarray.nth_dim, t[1]);
    }
  };

  var dims = function dims(t) {
    var variant = t[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Curry._1(Float64_genarray.dims, t[1]);
      } else {
        return Curry._1(Float32_genarray.dims, t[1]);
      }
    } else if (variant >= -661245189) {
      return Curry._1(Int64_genarray.dims, t[1]);
    } else {
      return Curry._1(Int32_genarray.dims, t[1]);
    }
  };

  var is_empty = function is_empty(t) {
    return num_dims(t) === 0;
  };

  var foldi = function foldi(init, f, data) {
    var num_dims$1 = num_dims(data);

    var unroll$prime = function unroll$prime(accum, indices) {
      var match = num_dims$1 === indices.length;

      if (match) {
        return Curry._3(f, indices, accum, get(data, indices));
      } else {
        var nth_dim$1 = Curry._1(nth_dim(data), indices.length);

        var stream = Stream.from(function (x) {
          var match = x < nth_dim$1;

          if (match) {
            return x;
          }
        });
        var _accum = accum;

        while (true) {
          var accum$1 = _accum;
          var i;

          try {
            i = Stream.next(stream);
          } catch (exn) {
            if (exn === Stream.Failure) {
              return accum$1;
            } else {
              throw exn;
            }
          }

          _accum = unroll$prime(accum$1, $$Array.append(indices,
          /* array */
          [i]));
          continue;
        }

        ;
      }
    };

    return unroll$prime(init,
    /* array */
    []);
  };

  var to_term = function to_term(t) {
    return t;
  };

  var sub_left_int = function sub_left_int(t, i, j) {
    if (t[0] >= -661245189) {
      return (
        /* `Int64_genarray */
        [-661245189, Curry._3(Int64_genarray.sub_left, t[1], i, j)]
      );
    } else {
      return (
        /* `Int32_genarray */
        [-714735238, Curry._3(Int32_genarray.sub_left, t[1], i, j)]
      );
    }
  };

  var sub_left_float = function sub_left_float(t, i, j) {
    if (t[0] >= 81581934) {
      return (
        /* `Float64_genarray */
        [81581934, Curry._3(Float64_genarray.sub_left, t[1], i, j)]
      );
    } else {
      return (
        /* `Float32_genarray */
        [28091885, Curry._3(Float32_genarray.sub_left, t[1], i, j)]
      );
    }
  };

  var sub_left = function sub_left(t, i, j) {
    if (t[0] >= 28091885) {
      return sub_left_float(t, i, j);
    } else {
      return sub_left_int(t, i, j);
    }
  };

  var slice_left_int = function slice_left_int(t, i) {
    if (t[0] >= -661245189) {
      return (
        /* `Int64_genarray */
        [-661245189, Curry._2(Int64_genarray.slice_left, t[1], i)]
      );
    } else {
      return (
        /* `Int32_genarray */
        [-714735238, Curry._2(Int32_genarray.slice_left, t[1], i)]
      );
    }
  };

  var slice_left_float = function slice_left_float(t, i) {
    if (t[0] >= 81581934) {
      return (
        /* `Float64_genarray */
        [81581934, Curry._2(Float64_genarray.slice_left, t[1], i)]
      );
    } else {
      return (
        /* `Float32_genarray */
        [28091885, Curry._2(Float32_genarray.slice_left, t[1], i)]
      );
    }
  };

  var slice_left = function slice_left(t, i) {
    if (t[0] >= 28091885) {
      return slice_left_float(t, i);
    } else {
      return slice_left_int(t, i);
    }
  };

  var singleton = function singleton(data) {
    return (
      /* `String_array */
      [-867361653,
      /* array */
      [data]]
    );
  };

  var empty_001 =
  /* array */
  [""];
  var empty =
  /* `String_array */
  [-867361653, empty_001];

  var of_array = function of_array(strings) {
    return (
      /* `String_array */
      [-867361653, strings]
    );
  };

  var of_matrix = function of_matrix(string_matrix) {
    return (
      /* `String_matrix */
      [-83649777, string_matrix]
    );
  };

  var create = function create(dims) {
    var len = dims.length;

    if (len < 3) {
      switch (len) {
        case 0:
          break;

        case 1:
          var x = dims[0];
          return (
            /* `String_array */
            [-867361653, Caml_array.caml_make_vect(x, "")]
          );

        case 2:
          var x$1 = dims[0];
          var y = dims[1];
          return (
            /* `String_matrix */
            [-83649777, ArrayLabels.make_matrix(x$1, y, "")]
          );
      }
    }

    return Pervasives.failwith(Curry._1(Printf.sprintf(
    /* Format */
    [
    /* String_literal */
    Block.__(11, ["invalid number of dimension: ",
    /* Int */
    Block.__(4, [
    /* Int_d */
    0,
    /* No_padding */
    0,
    /* No_precision */
    0,
    /* End_of_format */
    0])]), "invalid number of dimension: %d"]), dims.length));
  };

  var get$1 = function get$1(strings, indices) {
    var len = indices.length;

    if (len >= 3) {
      return Pervasives.failwith("invalid dimensions");
    } else {
      switch (len) {
        case 0:
          return Pervasives.failwith("invalid dimensions");

        case 1:
          var x = indices[0];

          if (typeof strings === "number" || strings[0] !== -867361653) {
            return Pervasives.failwith("invalid dimensions");
          } else {
            return Caml_array.caml_array_get(strings[1], x);
          }

        case 2:
          var x$1 = indices[0];
          var y = indices[1];

          if (typeof strings === "number" || strings[0] !== -83649777) {
            return Pervasives.failwith("invalid dimensions");
          } else {
            return Caml_array.caml_array_get(Caml_array.caml_array_get(strings[1], x$1), y);
          }

      }
    }
  };

  var num_dims$1 = function num_dims$1(t) {
    if (t[0] >= -83649777) {
      return 2;
    } else {
      return 1;
    }
  };

  var dims$1 = function dims$1(t) {
    if (t[0] >= -83649777) {
      var mat = t[1];
      var x = mat.length;

      if (x !== 0) {
        return (
          /* array */
          [x, Caml_array.caml_array_get(mat, 0).length]
        );
      } else {
        return (
          /* array */
          []
        );
      }
    } else {
      return (
        /* array */
        [t[1].length]
      );
    }
  };

  var set$1 = function set$1(t, indices, value) {
    if (t[0] >= -83649777) {
      if (indices.length === 2) {
        var x = indices[0];
        var y = indices[1];
        return Caml_array.caml_array_set(Caml_array.caml_array_get(t[1], x), y, value);
      }
    } else if (indices.length === 1) {
      var x$1 = indices[0];
      return Caml_array.caml_array_set(t[1], x$1, value);
    }

    return Pervasives.failwith(Curry._1(Printf.sprintf(
    /* Format */
    [
    /* String_literal */
    Block.__(11, ["invalid dimension for indices: ",
    /* Int */
    Block.__(4, [
    /* Int_d */
    0,
    /* No_padding */
    0,
    /* No_precision */
    0,
    /* End_of_format */
    0])]), "invalid dimension for indices: %d"]), indices.length));
  };

  var nth_dim$1 = function nth_dim$1(t, n) {
    return Caml_array.caml_array_get(dims$1(t), n);
  };

  var get_array = function get_array(t, indices) {
    var num_dims$2 = num_dims$1(t);
    var indices_len = indices.length;
    var dim_diff = num_dims$2 - indices_len | 0;

    if (dim_diff !== 1) {
      Pervasives.failwith(Curry._2(Printf.sprintf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["get_array: invalid index dimension: ",
      /* Int */
      Block.__(4, [
      /* Int_d */
      0,
      /* No_padding */
      0,
      /* No_precision */
      0,
      /* String_literal */
      Block.__(11, [", should be ",
      /* Int */
      Block.__(4, [
      /* Int_d */
      0,
      /* No_padding */
      0,
      /* No_precision */
      0,
      /* End_of_format */
      0])])])]), "get_array: invalid index dimension: %d, should be %d"]), indices_len, num_dims$2 - 1 | 0));
    }

    var last_dim = Caml_array.caml_array_get(dims$1(t), indices_len);
    return ArrayLabels.init(last_dim, function (i) {
      return get$1(t, $$Array.append(indices,
      /* array */
      [i]));
    });
  };

  var get_matrix = function get_matrix(t, indices) {
    var num_dims$2 = num_dims$1(t);
    var indices_len = indices.length;
    var dim_diff = num_dims$2 - indices_len | 0;

    if (dim_diff !== 2) {
      Pervasives.failwith(Curry._2(Printf.sprintf(
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["get_matrix: invalid index dimension: ",
      /* Int */
      Block.__(4, [
      /* Int_d */
      0,
      /* No_padding */
      0,
      /* No_precision */
      0,
      /* String_literal */
      Block.__(11, [", should be ",
      /* Int */
      Block.__(4, [
      /* Int_d */
      0,
      /* No_padding */
      0,
      /* No_precision */
      0,
      /* End_of_format */
      0])])])]), "get_matrix: invalid index dimension: %d, should be %d"]), indices_len, num_dims$2 - 2 | 0));
    }

    var last_dim = Caml_array.caml_array_get(dims$1(t), indices_len);
    return ArrayLabels.init(last_dim, function (i) {
      return get_array(t, $$Array.append(indices,
      /* array */
      [i]));
    });
  };

  var map$1 = function map$1(of_string, of_array, data) {
    var num_dims$2 = num_dims$1(data);

    var unroll$prime = function unroll$prime(indices) {
      var match = num_dims$2 === indices.length;

      if (match) {
        return Curry._1(of_string, get$1(data, indices));
      } else {
        return Curry._1(of_array, ArrayLabels.init(Caml_array.caml_array_get(dims$1(data), indices.length), function (i) {
          return unroll$prime($$Array.append(indices,
          /* array */
          [i]));
        }));
      }
    };

    return unroll$prime(
    /* array */
    []);
  };

  var foldi$1 = function foldi$1(init, f, data) {
    var num_dims$2 = num_dims$1(data);

    var unroll$prime = function unroll$prime(accum, indices) {
      var match = num_dims$2 === indices.length;

      if (match) {
        return Curry._3(f, indices, accum, get$1(data, indices));
      } else {
        return ArrayLabels.fold_left(function (accum$prime, i) {
          return unroll$prime(accum$prime, $$Array.append(indices,
          /* array */
          [i]));
        }, accum, ArrayLabels.init(Caml_array.caml_array_get(dims$1(data), indices.length), Bolt0_fn$Bolt0.id));
      }
    };

    return unroll$prime(init,
    /* array */
    []);
  };

  var to_term$1 = function to_term$1(t) {
    return (
      /* `Strings */
      [-968575390, t]
    );
  };

  var reverse_index = function reverse_index(to_data, t) {
    var init = Hashtbl.create(undefined, 100);
    var table = foldi$1(init, function (indices, hash, key) {
      var data = Curry._2(to_data, indices, key);

      Hashtbl.add(hash, key, data);
      return hash;
    }, t);
    return function (x) {
      try {
        return Caml_option.some(Hashtbl.find(table, x));
      } catch (exn) {
        if (exn === Caml_builtin_exceptions.not_found) {
          return;
        } else {
          throw exn;
        }
      }
    };
  };

  var size_in_bytes$1 = function size_in_bytes$1(t) {
    if (t[0] >= -83649777) {
      return ArrayLabels.fold_left(function (init, arr) {
        return ArrayLabels.fold_left(function (acc, s) {
          return acc + s.length | 0;
        }, init, arr);
      }, 0, t[1]);
    } else {
      return ArrayLabels.fold_left(function (acc, s) {
        return acc + s.length | 0;
      }, 1, t[1]);
    }
  };

  var is_empty$1 = function is_empty$1(t) {
    var match = num_dims$1(t);
    return match === 0;
  };

  var length = function length(t) {
    if (is_empty$1(t)) {
      return Int64.zero;
    } else {
      return ArrayLabels.fold_left(function (acc, x) {
        return Caml_int64.mul(acc, Caml_int64.of_int32(x));
      }, Int64.one, dims$1(t));
    }
  };

  var sub_left$1 = function sub_left$1(t, i, j) {
    if (t[0] >= -83649777) {
      return (
        /* `String_matrix */
        [-83649777, ArrayLabels.sub(t[1], i, j)]
      );
    } else {
      return (
        /* `String_array */
        [-867361653, ArrayLabels.sub(t[1], i, j)]
      );
    }
  };

  var slice_left$1 = function slice_left$1(t, i) {
    var len = i.length;

    if (len >= 3) {
      return Pervasives.failwith("slice_left: invalid indices");
    } else {
      switch (len) {
        case 0:
          return Pervasives.failwith("slice_left: invalid indices");

        case 1:
          var len$1 = i[0];

          if (t[0] >= -83649777) {
            var mat = t[1];
            return (
              /* `String_matrix */
              [-83649777, ArrayLabels.init(len$1, function (param) {
                return Caml_array.caml_array_get(mat, param);
              })]
            );
          } else {
            var arr = t[1];
            return (
              /* `String_array */
              [-867361653, ArrayLabels.init(len$1, function (param) {
                return Caml_array.caml_array_get(arr, param);
              })]
            );
          }

        case 2:
          var len_x = i[0];
          var len_y = i[1];

          if (typeof t === "number" || t[0] !== -83649777) {
            return Pervasives.failwith("slice_left: invalid indices");
          } else {
            var mat$1 = t[1];
            return (
              /* `String_matrix */
              [-83649777, ArrayLabels.map(function (arr) {
                return ArrayLabels.init(len_y, function (param) {
                  return Caml_array.caml_array_get(arr, param);
                });
              }, ArrayLabels.init(len_x, function (param) {
                return Caml_array.caml_array_get(mat$1, param);
              }))]
            );
          }

      }
    }
  };

  var foldi$2 = function foldi$2(init, f, t) {
    if (t[0] >= -714735238) {
      return foldi(init, Curry.__3(f), t);
    } else {
      return foldi$1(init, function (indices, acc, x) {
        return Curry._3(f, indices, acc,
        /* `String */
        [-976970511, x]);
      }, t[1]);
    }
  };

  var set$2 = function set$2(t, indices, value) {
    if (t[0] >= -714735238) {
      if (value[0] >= 3654863) {
        return set(t, indices, value);
      } else {
        return Pervasives.failwith("can't set string value on a numeric bigdata type");
      }
    } else if (value[0] >= 3654863) {
      return Pervasives.failwith("can't set numeric value on a strings bigdata type");
    } else {
      return set$1(t[1], indices, value[1]);
    }
  };

  var dims$2 = function dims$2(n) {
    if (n[0] >= -714735238) {
      return dims(n);
    } else {
      return dims$1(n[1]);
    }
  };

  var num_dims$2 = function num_dims$2(n) {
    if (n[0] >= -714735238) {
      return num_dims(n);
    } else {
      return num_dims$1(n[1]);
    }
  };

  var nth_dim$2 = function nth_dim$2(n) {
    if (n[0] >= -714735238) {
      return nth_dim(n);
    } else {
      var partial_arg = n[1];
      return function (param) {
        return nth_dim$1(partial_arg, param);
      };
    }
  };

  var get$2 = function get$2(t, indices) {
    if (t[0] >= -714735238) {
      return get(t, indices);
    } else {
      return (
        /* `String */
        [-976970511, get$1(t[1], indices)]
      );
    }
  };

  var int_exn$1 = function int_exn$1(t, indices) {
    if (t[0] >= -714735238) {
      return int_exn(get(t, indices));
    } else {
      return Pervasives.failwith("int_exn: expected integer bigdata but got strings");
    }
  };

  var float_exn$1 = function float_exn$1(t, indices) {
    if (t[0] >= -714735238) {
      return float_exn(get(t, indices));
    } else {
      return Pervasives.failwith("int_exn: expected float bigdata but got strings");
    }
  };

  var string_exn = function string_exn(t, indices) {
    if (t[0] >= -714735238) {
      return Pervasives.failwith("strings_exn: expected strings bigdata but got numeric");
    } else {
      return get$1(t[1], indices);
    }
  };

  var length$1 = function length$1(x) {
    return ArrayLabels.fold_left(Caml_int32.imul, 1, dims$2(x));
  };

  var sub_left$2 = function sub_left$2(t, i, j) {
    if (t[0] >= -714735238) {
      return sub_left(t, i, j);
    } else {
      return (
        /* `Strings */
        [-968575390, sub_left$1(t[1], i, j)]
      );
    }
  };

  var slice_left$2 = function slice_left$2(t, i) {
    if (t[0] >= -714735238) {
      return slice_left(t, i);
    } else {
      return (
        /* `Strings */
        [-968575390, slice_left$1(t[1], i)]
      );
    }
  };

  var pp_hum = function pp_hum(ppf, bigdata) {
    var variant = bigdata[0];

    if (variant !== -714735238) {
      if (variant >= 28091885) {
        if (variant >= 81581934) {
          return Format.fprintf(ppf,
          /* Format */
          [
          /* String_literal */
          Block.__(11, ["<float64-genarray>",
          /* End_of_format */
          0]), "<float64-genarray>"]);
        } else {
          return Format.fprintf(ppf,
          /* Format */
          [
          /* String_literal */
          Block.__(11, ["<float32-genarray>",
          /* End_of_format */
          0]), "<float32-genarray>"]);
        }
      } else if (variant >= -661245189) {
        return Format.fprintf(ppf,
        /* Format */
        [
        /* String_literal */
        Block.__(11, ["<int64-genarray>",
        /* End_of_format */
        0]), "<int64-genarray>"]);
      } else {
        return Format.fprintf(ppf,
        /* Format */
        [
        /* String_literal */
        Block.__(11, ["<strings>",
        /* End_of_format */
        0]), "<strings>"]);
      }
    } else {
      return Format.fprintf(ppf,
      /* Format */
      [
      /* String_literal */
      Block.__(11, ["<int32-genarray>",
      /* End_of_format */
      0]), "<int32-genarray>"]);
    }
  };

  var cell_format = function cell_format(t) {
    var variant = t[0];

    if (variant >= -714735238) {
      if (variant >= 28091885) {
        return (
          /* Float */
          365180284
        );
      } else {
        return (
          /* Int */
          3654863
        );
      }
    } else {
      return (
        /* String */
        -976970511
      );
    }
  };

  var M_Numeric = {
    create_float32: create_float32,
    create_float64: create_float64,
    create_int32: create_int32,
    create_int64: create_int64,
    int_exn: int_exn,
    float_exn: float_exn,
    empty_float32: empty_float32,
    get_float: get_float,
    get_int: get_int,
    get: get,
    set_int: set_int,
    set_float: set_float,
    set: set,
    map: map,
    num_dims: num_dims,
    size_in_bytes: size_in_bytes,
    nth_dim: nth_dim,
    dims: dims,
    is_empty: is_empty,
    foldi: foldi,
    to_term: to_term,
    sub_left: sub_left,
    sub_left_int: sub_left_int,
    sub_left_float: sub_left_float,
    slice_left: slice_left,
    slice_left_int: slice_left_int,
    slice_left_float: slice_left_float
  };
  var M_Strings = {
    singleton: singleton,
    empty: empty,
    of_array: of_array,
    of_matrix: of_matrix,
    create: create,
    get: get$1,
    num_dims: num_dims$1,
    dims: dims$1,
    nth_dim: nth_dim$1,
    get_array: get_array,
    get_matrix: get_matrix,
    map: map$1,
    foldi: foldi$1,
    to_term: to_term$1,
    reverse_index: reverse_index,
    size_in_bytes: size_in_bytes$1,
    is_empty: is_empty$1,
    length: length,
    sub_left: sub_left$1,
    slice_left: slice_left$1,
    set: set$1
  };
  var M = {
    Numeric: M_Numeric,
    Strings: M_Strings,
    foldi: foldi$2,
    get: get$2,
    num_dims: num_dims$2,
    nth_dim: nth_dim$2,
    dims: dims$2,
    int_exn: int_exn$1,
    float_exn: float_exn$1,
    string_exn: string_exn,
    length: length$1,
    slice_left: slice_left$2,
    sub_left: sub_left$2,
    pp_hum: pp_hum,
    set: set$2,
    cell_format: cell_format
  };
  var include = M_Numeric;
  var Numeric = include;
  return {
    M: M,
    Numeric: Numeric,
    Strings: M_Strings,
    foldi: foldi$2,
    get: get$2,
    num_dims: num_dims$2,
    nth_dim: nth_dim$2,
    dims: dims$2,
    int_exn: int_exn$1,
    float_exn: float_exn$1,
    string_exn: string_exn,
    length: length$1,
    slice_left: slice_left$2,
    sub_left: sub_left$2,
    pp_hum: pp_hum,
    set: set$2,
    cell_format: cell_format
  };
}

export { Make, Make_sexp };
/* Format Not a pure module */